export default __webpack_public_path__ + "static/step2@2x-baa52db699590a91bc97bfd26788ffc1.png";